/**
 * This enum is only used, because we are tracking the active transaction on the frontend as well.
 */
export enum TransactionValidation {
    LoadingOrNotFound,
    Valid,
    Invalid,
}
